import { render, staticRenderFns } from "./expenditureStatistics.vue?vue&type=template&id=2ad2d399&scoped=true&"
import script from "./expenditureStatistics.vue?vue&type=script&lang=js&"
export * from "./expenditureStatistics.vue?vue&type=script&lang=js&"
import style0 from "./expenditureStatistics.vue?vue&type=style&index=0&id=2ad2d399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2d399",
  null
  
)

export default component.exports